import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const TermConditions = () => {
  return (
    <>
     <Header/>
          <h6>Term and Condition Page</h6>
     <Footer/> 
    </>
  )
}

export default TermConditions
